import { useState } from "react";
import { Megaphone, LifeBuoy } from "lucide-react";
import { MarketingAdminPanel } from "../MarketingAdminPanel";
import { DemoCloneButton } from "../DemoCloneButton";
import { PaymentRequestsButton } from "../PaymentRequestsAdmin";
import { ZatcaCompaniesButton } from "../ZatcaCompaniesAdmin";
import { WhatsappCompaniesButton } from "../WhatsappCompaniesAdmin";
import { OwnerWaBroadcast } from "../OwnerWaBroadcast";
import { OwnerAdsManager } from "../OwnerAdsManager";

const Tile = ({ title, desc, children, testid }) => (
  <div className="pc-rise flex flex-col justify-between gap-4 rounded-2xl border border-slate-200/70 bg-white p-5 transition-shadow hover:shadow-md" data-testid={testid}>
    <div><p className="font-heading font-bold text-slate-900">{title}</p><p className="mt-1 text-xs leading-relaxed text-slate-500">{desc}</p></div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const PcMarketing = () => {
  const [tab, setTab] = useState(null);
  const btn = "inline-flex items-center gap-1.5 rounded-xl border px-3 py-2 text-sm font-medium transition-colors";
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="pc-marketing">
      <Tile title="منصة التسويق" desc="المسوّقون، العملاء المحتملون، العمولات ومتابعة الأداء." testid="pc-tile-marketing">
        <button className={`${btn} border-emerald-200 text-emerald-700 hover:bg-emerald-50`} onClick={() => setTab("overview")} data-testid="pc-open-marketing"><Megaphone className="h-4 w-4" /> فتح التسويق</button>
        <button className={`${btn} border-blue-200 text-blue-700 hover:bg-blue-50`} onClick={() => setTab("support")} data-testid="pc-open-support"><LifeBuoy className="h-4 w-4" /> الدعم الفني</button>
      </Tile>
      <Tile title="الإعلانات والكوبونات" desc="عروض الشركاء والإعلانات داخل المنصة." testid="pc-tile-ads"><OwnerAdsManager /></Tile>
      <Tile title="بث واتساب للعملاء" desc="رسائل جماعية لمدراء الشركات المشتركة." testid="pc-tile-broadcast"><OwnerWaBroadcast /></Tile>
      <MarketingAdminPanel open={!!tab} onOpenChange={(v) => !v && setTab(null)} initialTab={tab || "overview"} key={tab || "x"} />
    </div>
  );
};

export const PcTools = () => (
  <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="pc-tools">
    <Tile title="طلبات الدفع" desc="مراجعة واعتماد طلبات الدفع والتحويلات البنكية من الشركات." testid="pc-tile-payments"><PaymentRequestsButton /></Tile>
    <Tile title="شركات ZATCA" desc="متابعة ربط الفوترة الإلكترونية لكل شركة." testid="pc-tile-zatca"><ZatcaCompaniesButton /></Tile>
    <Tile title="واتساب الشركات" desc="اشتراكات وإعدادات الواتساب لكل شركة." testid="pc-tile-whatsapp"><WhatsappCompaniesButton /></Tile>
    <Tile title="نسخة تجريبية (Demo)" desc="إنشاء نسخة ديمو للعرض على العملاء." testid="pc-tile-demo"><DemoCloneButton /></Tile>
  </div>
);
